"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStatus = void 0;
const resource_model_1 = require("./resource.model");
/**
 * The status related to an app's version.
 */
class AppStatus extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.version = this.clean(x.version, String);
        this.inMaintenance = this.clean(x.inMaintenance, Boolean);
        this.mustUpdate = this.clean(x.mustUpdate, Boolean);
        this.content = this.clean(x.content, String);
        this.latestVersion = this.clean(x.latestVersion, String);
    }
}
exports.AppStatus = AppStatus;
